var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.465,
    height: 12.48,
    viewBox: "0 0 12.465 12.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-reload",
    "data-name": "Icon open-reload",
    d: "M6.24,0a6.24,6.24,0,1,0,4.431,10.671L9.548,9.548A4.684,4.684,0,1,1,6.225,1.56,4.538,4.538,0,0,1,9.485,2.98l-1.7,1.7h4.68V0L10.608,1.856A6.205,6.205,0,0,0,6.225,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.2906f58c3504587057b27f9e08e30c9f.svg";
export { ForwardRef as ReactComponent };